import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    title: 'Настройки',
    navProfile: 'Профиль',
    navUsage: 'Использование',
    navConnectors: 'Коннекторы',
    emailAlreadyUsed: 'Этот email уже используется.',
    emailLimitReached: 'Почту можно менять не чаще двух раз в месяц.',
    emailCodeSent: (email: string) => `Мы отправили код на ${email}. Введите его ниже.`,
    emailHint:
      'Почта общая для студии и академии: она поменяется везде. Мы пришлём код для подтверждения.',
  },
  en: {
    title: 'Settings',
    navProfile: 'Profile',
    navUsage: 'Usage',
    navConnectors: 'Connectors',
    emailAlreadyUsed: 'This email is already in use.',
    emailLimitReached: 'You can change your email no more than twice a month.',
    emailCodeSent: (email: string) => `We sent a code to ${email}. Enter it below.`,
    emailHint:
      "Your email is shared by OA Studio and Open Academy, so it will change in both. We'll send you a confirmation code.",
  },
})
